import React, { useContext, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import GenderForm from './components/genderForm';
import BirthdayForm from './components/birthdayForm';
import EmailForm from './components/emailForm';
import NameForm from './components/nameForm';
import PasswordForm from './components/passwordForm';
import PromoStep from './components/promoStep';
import PopUp from "./components/PopUp";
import { Footer } from './components/Footer';
import { getTTI, sendScreenResolution, simplyClick } from './helpers';
import { landingId } from "./constants";
import { useAppendLandingId } from "./hooks/useAppendLandingId";
import { useSessionData } from "ui-components";
import { ContextProfileUser } from "./lib/profileContext";

function App() {
  const [step, setStep] = useState(1);
  const [showPopUp, setShowPopUp] = useState(false);
  const footer = document.getElementById('footer');
  let content = null;

  const { data, setData } = useContext(ContextProfileUser);
  const { getSessionData, saveSessionData } = useSessionData(landingId);

  useEffect(() => {
    const saved = getSessionData();
    if (saved) {
      setData(saved);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      saveSessionData(data);
    }
  }, [data, saveSessionData]);

  useAppendLandingId(landingId);  

  const openPopUp = (e) => {
    if (e.target === e.currentTarget) {
      setShowPopUp(true);
      simplyClick("cl_lnd_photos", { step });
    }
  };

  const closePopUp = () => {
    setShowPopUp(false);
  };

  useEffect(() => {
    let popupRoot = document.getElementById("popup-root");
    if (!popupRoot) {
      popupRoot = document.createElement("div");
      popupRoot.id = "popup-root";
      document.body.appendChild(popupRoot);
    }

    const timer = setTimeout(() => {
      getTTI();
      sendScreenResolution();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [step]);

  useEffect(() => {
    const registerGoogleContainer = document.querySelector(".content__wrapper");
    if (!registerGoogleContainer || showPopUp) return;

    let mouseDownTarget = null;

    const handleMouseDown = (e) => {
      mouseDownTarget = e.target;
    };

    const handleClick = (e) => {
      if (
        e.target === e.currentTarget &&
        mouseDownTarget === e.currentTarget
      ) {
        openPopUp(e);
      }
      mouseDownTarget = null;
    };

    registerGoogleContainer.addEventListener("mousedown", handleMouseDown);
    registerGoogleContainer.addEventListener("click", handleClick);

    return () => {
      registerGoogleContainer.removeEventListener("mousedown", handleMouseDown);
      registerGoogleContainer.removeEventListener("click", handleClick);
    };
  }, [step, showPopUp]);

  useEffect(() => {
    const wrapper = document.querySelector(".content__wrapper");
    if (!wrapper) return;

    let position = 0;
    const speed = 0.5;
    let lastTimestamp = performance.now();
    let animationFrameId;

    const animateBg = (timestamp) => {
      const elapsed = timestamp - lastTimestamp;
      lastTimestamp = timestamp;

      position += speed * (elapsed / 16);
      wrapper.style.backgroundPosition = `${position}px 56px`;

      animationFrameId = requestAnimationFrame(animateBg);
    };

    animationFrameId = requestAnimationFrame(animateBg);

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  switch (step) {
    case 2:
      content = (
        <>
          <GenderForm nextStep={() => setStep(3)} />
        </>
      );
      break;

    case 3:
      content = (
        <>
          <BirthdayForm nextStep={() => setStep(4)} />
        </>
      );
      break;
    case 4:
      content = (
        <>
          <NameForm nextStep={() => setStep(5)} />
        </>
      );
      break;
    case 5:
      content = (
        <>
          <EmailForm nextStep={() => setStep(6)} />
        </>
      );
      break;
    case 6:
      content = (
        <>
          <PasswordForm nextStep={() => setStep(7)} />
        </>
      );
      break;
    default:
      content = (
        <>
          <PromoStep nextStep={() => setStep(2)} />
        </>
      );
      break;
  }

  return (
    <>
      {showPopUp &&
        createPortal(
          <PopUp step={step} closePopUp={closePopUp} />,
          document.getElementById("popup-root")
        )}
      {content}
      {footer && createPortal(<Footer step={step} />, footer)}
    </>
  );
}

export default App;
